import React, { Component } from 'react';
import { Row, Col, Input, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import DashboardTile from './DashboardTile';
import ReactDragListView from 'react-drag-listview'
import PermissionWrapper from '../../../auth/PermissionWrapper';
import { Link } from 'react-router-dom';
import './Dashboards.css';
import * as utilities from '../../../utilities';
import CompanyContext from '../../../auth/CompanyContext';

class Dashboard extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);
        this.state = {
            dashboards: [],
            editActive: false,
            pageSize: localStorage.getItem('homePageSize') != null ? parseInt(localStorage.getItem('homePageSize')) : 10,
        };
    }

    componentDidMount() {
        utilities.log('Dashboard.js/componentDidMount');
        this.updateDocumentTitle();
        this.getDashboards();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.companySettings !== this.props.companySettings) {
            this.updateDocumentTitle();
        }
    }

    getDashboardTitle = () => {
        return this.props.companySettings?.CompanyDisplayName || this.props.companySettings?.CompanyName || 'CRM Application';
    }

    updateDocumentTitle = () => {
        document.title = this.getDashboardTitle();
    }

    getDashboards = () => {
        utilities.log('Dashboard.js/getDashboards');
        fetch('/api/dashboards/' + this.props.user, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        dashboards: results.data
                    });
                } else {
                    utilities.addToast('Unable to load dashboards.', 5, 'danger');
                }
            })
            .catch(() => {
                utilities.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleChange = (dashboardTileId, key, val) => {
        utilities.log('Dashboard.js/handleChange (dashboardTileId, key, val)', dashboardTileId, key, val);
        this.setState((prevState) => {
            let sel = prevState;
            const index = sel.dashboards.findIndex(item => item.dashboardTileId === parseInt(dashboardTileId));
            if (sel.dashboards[index].userConfiguration == null) sel.dashboards[index].userConfiguration = {};
            if (sel.dashboards[index].userConfiguration[key] == null) sel.dashboards[index].userConfiguration[key] = null;
            sel.dashboards[index].userConfiguration[key] = val;
            return sel;
        }, () => this.reorder())
    }

    reorder = (data = [...this.state.dashboards]) => {
        utilities.log('Dashboard.js/reorder()');
        let dbDashboards = [];
        let counter = 0;
        data = data.map((dashboard) => {
            let newOrder = null;
            if (dbDashboards.findIndex(item => item.DashboardTileId === dashboard.DashboardTileId) === -1) {
                dbDashboards.push({ dashboardTileId: dashboard.DashboardTileId })
                newOrder = (dashboard.UserActive ? ((counter + 1) * 10) : null);
                if (dashboard.UserActive) counter++;
            }
            return { ...dashboard, UserOrder: newOrder }
        })
        this.setState({ dashboards: data }, () => {
            fetch('/api/dashboards/' + this.props.user, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken,
                    'X-Database': this.context.company
                },
                body: JSON.stringify(
                    { dashboards: data }
                )
            })
                .catch(() => {
                    utilities.addToast('An error has occurred.', 5, 'danger');
                })
        });
    }

    setPageSize = (pageSize) => {
        this.setState({ pageSize: pageSize }, () => localStorage.setItem('homePageSize', pageSize))
    }

    addCompany = () => {
        fetch('/api/demographics/', {
            method: 'POST',
            body: JSON.stringify(this.state),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then((results) => {
                if (results.success) {
                    localStorage.setItem('demographicsActiveTab', 2)
                    this.props.history.push({
                        pathname: `/demographics/${results.data}`,
                    });
                }
            })
    }

    render() {
        utilities.info('Dashboard.js/render');
        const dashboardTitle = this.getDashboardTitle();
        const dragProps = {
            onDragEnd: (fromIndex, toIndex) => {
                // console.log(fromIndex, toIndex)
                const data = [...this.state.dashboards];
                const item = data.splice(fromIndex, 1)[0];
                data.splice(toIndex, 0, item);
                this.reorder(data);
            },
            nodeSelector: 'div.dashboardTile',
            handleSelector: 'div.dragIcon',
            className: 'w-100'
        };
        return (
            <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Home Dashboard Tiles">
                <PermissionWrapper {...this.props} allowedPermission="Show Secondary Ribbon" hidden={true}>
                    <Row className='align-items-cexnter'>
                        <Col md={3}></Col>
                        <Col md={6} className="text-center"><h1>{dashboardTitle}</h1></Col>
                        <Col md={3} className='text-right pt-4 pr-4'>
                            <Button color='primary' onClick={this.addCompany}>Add Company</Button>
                            <Link className="btn btn-primary ml-2" to={{ pathname: '/contacts', state: { modalOpen: true } }}>Add Contact</Link>
                        </Col>
                    </Row>
                </PermissionWrapper>
                <Row>
                    <Col>
                        <ReactDragListView.DragColumn {...dragProps}>
                            <Row className='dashboardTilesRow'>
                                {[...this.state.dashboards].sort((a, b) => a.UserOrder - b.UserOrder).map((item) => (
                                    <DashboardTile
                                        {...this.props}
                                        key={item.DashboardTileId}
                                        id={item.DashboardTileId}
                                        name={item.Name}
                                        types={item.Types}
                                        dashboardTile={item}
                                        widths={(item.Configuration != null && item.Configuration.widths != null && item.Configuration.widths.length > 0) ? item.Configuration.widths : [6]}
                                        width={6}
                                        // width={(item.UserConfiguration != null && item.UserConfiguration.width != null && item.UserConfiguration.width > 0) ? item.UserConfiguration.width :
                                            // ((item.Configuration != null && item.Configuration.defaultWidth != null && item.Configuration.defaultWidth > 0) ? item.Configuration.defaultWidth : 6)}
                                        active={item.UserActive}
                                        pageSize={this.state.pageSize}
                                        setPageSize={this.setPageSize}
                                        handleChange={this.handleChange}
                                    />
                                ))}
                            </Row>
                        </ReactDragListView.DragColumn>
                    </Col>
                </Row>
                <Row>
                    <Col className="text-left py-3 pl-5">
                        {!this.state.editActive ?
                            <Button onClick={() => this.setState({ editActive: true })} color="primary">Configure Dashboard</Button>
                            :
                            <Row>
                                <Col>
                                    <h4 className='mb-3'>Company Tiles</h4>
                                    {[...this.state.dashboards].sort((a, b) => a.Order - b.Order).map(item => (
                                        <div key={item.DashboardTileId}>
                                            <label><Input
                                                type="checkbox"
                                                checked={utilities.isFieldNull(item.UserActive, true)}
                                                name={"dashboardTile_" + item.DashboardTileId}
                                                onChange={(e) => {
                                                    const targetName = e.target.name;
                                                    this.setState((prevState) => {
                                                        const sel = { ...prevState };
                                                        const dashboardTile = sel.dashboards.find(item => ("dashboardTile_" + item.DashboardTileId) === targetName);
                                                        if (dashboardTile) {
                                                            dashboardTile.UserActive = !dashboardTile.UserActive;
                                                        }
                                                        return sel;
                                                    }, () => this.reorder());
                                                }}
                                            />
                                                {item.Name}
                                            </label>
                                        </div>
                                    ))}
                                </Col>
                                <Col md={4} className='pt-4'>
                                    <Button onClick={() => this.setState({ editActive: false })} color="secondary">Done</Button>
                                </Col>
                            </Row>
                        }
                    </Col>
                </Row>
            </PermissionWrapper>
        );
    }
}

export default Dashboard;
